module.exports = __webpack_public_path__ + "static/photo-f06952d49521598dccb979acb7f2e22c.jpg";